import { useEffect, useState } from 'react'

export const usePaymentOptions = (paymentOptions, configEnabledPaymentMethods, optimizely) => {
    const savedPaymentMethods = paymentOptions.filter((item) => item?.cardId || (item.id !== 'CREDIT_CARD' && item?.selected))
    const isExpired = savedPaymentMethods.filter((item) => item?.expired).length > 0
    const noSavedPaymentMethod = savedPaymentMethods.length === 0
    const hasOnePaymentMethod = savedPaymentMethods.length === 1
    const hasMoreThanOneSavedPaymentMethod = savedPaymentMethods.length > 1

    const [canChangePayment, setCanChangePayment] = useState(hasMoreThanOneSavedPaymentMethod)
    const [canAddPayment, setCanAddPayment] = useState(hasOnePaymentMethod && !isExpired)
    const [activePaymentOptions, setActivePaymentOptions] = useState(paymentOptions)

    const handleChangePayment = () => {
        optimizely?.track('change_payment')
        setCanAddPayment(true)
        setCanChangePayment(false)
    }

    const handleAddPayment = () => {
        optimizely?.track('add_new_payment')
        setCanAddPayment(false)
        setCanChangePayment(false)
    }

    const isDisabledInConfig = (paymentMethods) => {
        const payment = configEnabledPaymentMethods?.find((payment) => {
            return paymentMethods?.[0]?.id?.includes(payment?.name)
        })
        return payment ? !payment?.enabled : false
    }

    const processOptions = () => {
        if (noSavedPaymentMethod) {
            return paymentOptions
        }

        if (hasMoreThanOneSavedPaymentMethod && canChangePayment === true && canAddPayment === false) {
            const filteredPaymentMethods = savedPaymentMethods.filter((item) => item.selected)

            if (isDisabledInConfig(filteredPaymentMethods)) {
                setCanChangePayment(false)
                setCanAddPayment(savedPaymentMethods.length > 1)
            }

            if (filteredPaymentMethods.length > 0) {
                return filteredPaymentMethods
            } else {
                setCanAddPayment(true)
                setCanChangePayment(false)
                return savedPaymentMethods
            }
        }

        if (savedPaymentMethods.length > 0 && canChangePayment === false && canAddPayment === true) {
            if (hasOnePaymentMethod && isDisabledInConfig(savedPaymentMethods)) {
                setCanAddPayment(false)
            }
            return savedPaymentMethods
        }

        return paymentOptions
    }

    useEffect(() => {
        setActivePaymentOptions(processOptions())
    }, [canChangePayment, canAddPayment, paymentOptions])

    return { activePaymentOptions, canChangePayment, canAddPayment, handleChangePayment, handleAddPayment }
}
